import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
} from '@angular/core';
import { BreakpointSize } from '@common';

@Component({
  selector: 'app-grid-column',
  styleUrls: ['./grid-column.component.scss'],
  templateUrl: './grid-column.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridColumnComponent {
  xs = input<number>(12);
  sm = input<number>();
  md = input<number>();
  lg = input<number>();
  xl = input<number>();
  block = input<BreakpointSize>();
  hidden = input<BreakpointSize>();

  @HostBinding('class')
  get cssClasses(): string {
    return [
      'grid-column',
      this.xs() && `grid-column--xs${this.xs()}`,
      this.sm() && `grid-column--sm${this.sm()}`,
      this.md() && `grid-column--md${this.md()}`,
      this.lg() && `grid-column--lg${this.lg()}`,
      this.xl() && `grid-column--xl${this.xl()}`,
      this.block() && `grid-column--block-${this.block()}`,
      this.hidden() && `grid-column--hidden-${this.hidden()}`,
    ]
      .filter(Boolean)
      .join(' ');
  }
}
